import React, { FC, ReactNode, useEffect, useState } from 'react'
import { useHistory, useRouteMatch } from 'react-router-dom'
import { ShepherdOptionsWithType } from 'react-shepherd'
import useDraft from '../../../redux/draft-drawer/useDraft'
import ROUTES from '../../utils/routes'
import generateNewPostTour from './generateNewPostTour'
import { useIsDesktop } from '../../utils/useIsDesktop'
import { Tour } from '..'

type Props = {
  children: ReactNode;
}

const NewPostTour: FC<Props> = ({ children }) => {
  const TOUR_ID = 'create_post'
  const history = useHistory()
  const isDashboard = useRouteMatch(ROUTES.dashboard.home)?.isExact
  const { isDesktop } = useIsDesktop()
  const [steps, setSteps] = useState<ShepherdOptionsWithType[]>([])
  const { actions: { clearAndCloseDraft } } = useDraft()

  useEffect(() => {
    if (isDesktop === undefined) {
      return
    }

    setSteps(generateNewPostTour(!isDesktop, clearAndCloseDraft))
  }, [isDesktop])

  return (
    <Tour
      _id={TOUR_ID}
      steps={steps}
      canStart={isDashboard}
      onTourComplete={() => history.push(ROUTES.dashboard.home)}
    >
      {children}
    </Tour>
  )
}

export default NewPostTour
